// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginLayout_page__9xLw9 {
  display: flex;
  width: 100%;
  height: 100vh;
  min-height: 560px;
  padding: 0;
  gap: 0;
  background: #fff;
  color: #1f1f2e;
  box-sizing: border-box;
}

.LoginLayout_left__wLC52 {
  padding: 24px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  flex: 1 1 50%;
  min-width: 0;
}

.LoginLayout_header__8uZat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  min-height: 40px;
}

.LoginLayout_logo-img__Pwqs\\+ {
  height: 36px;
  width: auto;
}

.LoginLayout_main__PVL5R {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
}

.LoginLayout_card__Ik0MG {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
}
.LoginLayout_card__Ik0MG form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.LoginLayout_title__rkJDc {
  margin: 0 0 8px;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--lg-title);
}

.LoginLayout_subtitle__30W-j {
  margin: 0 0 28px;
  font-size: 14px;
  line-height: 1.5;
  color: #55556a;
}

.LoginLayout_field__jizQt {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.LoginLayout_field__jizQt label {
  font-size: 12px;
  font-weight: 600;
  color: #1f1f2e;
}
.LoginLayout_field__jizQt input {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #55556a;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
  outline: none;
}
.LoginLayout_field__jizQt input:focus {
  border-color: var(--lg-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--lg-primary) 20%, transparent);
}

.LoginLayout_password__qSxGe {
  position: relative;
}

.LoginLayout_password__qSxGe input {
  padding-right: 40px;
}

.LoginLayout_eye__SYfVf {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  padding: 4px;
  border: 0;
  background: none;
  cursor: pointer;
}
.LoginLayout_eye__SYfVf svg path {
  fill: var(--lg-dark);
}

.LoginLayout_forgot__Qdp58 {
  align-self: flex-end;
  margin-top: -8px;
  font-size: 12px;
}

.LoginLayout_link__ArUGf, .LoginLayout_forgot__Qdp58, .LoginLayout_footer__lsm4Q a {
  color: var(--lg-primary);
  text-decoration: none;
}
.LoginLayout_link__ArUGf:hover, .LoginLayout_forgot__Qdp58:hover, .LoginLayout_footer__lsm4Q a:hover {
  text-decoration: underline;
}

.LoginLayout_submit__yLtTL {
  align-self: center;
  min-width: 150px;
  height: 40px;
  margin-top: 8px;
  padding: 0 24px;
  border: 0;
  border-radius: 6px;
  background: var(--lg-primary);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.LoginLayout_submit__yLtTL:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.LoginLayout_submit__yLtTL:not(:disabled):hover {
  background: var(--lg-mid);
}

.LoginLayout_alt__4FoeL {
  margin-top: 24px;
  text-align: center;
  font-size: 12px;
  color: #55556a;
}

.LoginLayout_error__dodKf {
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fdecee;
  color: #a50f1d;
  font-size: 12px;
}

.LoginLayout_field-error__Ivzzk {
  font-size: 11px;
  line-height: 1.5;
  color: var(--lg-mid);
}

.LoginLayout_success__DiyX2 {
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #e8f6ec;
  color: #1d6b34;
  font-size: 12px;
}

.LoginLayout_footer__lsm4Q {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px 0;
  border-top: 1px solid #ececf2;
  font-size: 11px;
  color: #55556a;
}

.LoginLayout_footer__lsm4Q .LoginLayout_footer-link__4xk-U {
  color: inherit;
  text-decoration: none;
}
.LoginLayout_footer__lsm4Q .LoginLayout_footer-link__4xk-U:hover {
  color: var(--lg-primary);
  text-decoration: underline;
}

.LoginLayout_secure__a5THh {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.LoginLayout_secure__a5THh svg {
  width: 12px;
  height: 12px;
}
.LoginLayout_secure__a5THh path {
  fill: currentColor;
}

.LoginLayout_visual__leyTl {
  position: relative;
  flex: 1 1 50%;
  align-self: stretch;
  border-radius: 14px 0 0 14px;
  overflow: hidden;
  background-color: var(--lg-primary);
  background-image: radial-gradient(ellipse 34% 30% at 55% 55%, rgba(255, 255, 255, 0.32) 0, rgba(255, 255, 255, 0) 100%), radial-gradient(ellipse 45% 40% at 100% 0%, var(--lg-dark) 0, transparent 100%), radial-gradient(ellipse 55% 45% at 0% 78%, var(--lg-dark) 0, transparent 100%), linear-gradient(135deg, var(--lg-primary) 0%, var(--lg-primary) 100%);
  background-size: cover;
  background-position: center;
}

.LoginLayout_glass__JaNSt {
  position: absolute;
  left: 5%;
  bottom: 5%;
  width: 50%;
  min-width: 260px;
  padding: 28px 32px 22px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(14px);
  color: #fff;
}
.LoginLayout_glass__JaNSt p {
  margin: 0 0 16px;
  font-size: 16px;
  line-height: 2;
  font-weight: 400;
}
.LoginLayout_glass__JaNSt ul {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.LoginLayout_glass__JaNSt li {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  font-size: 10px;
  font-weight: 500;
}
.LoginLayout_glass__JaNSt li::before {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff;
}

@media (max-width: 900px) {
  .LoginLayout_page__9xLw9 {
    height: auto;
    min-height: 100vh;
  }
  .LoginLayout_visual__leyTl {
    display: none;
  }
}
.LoginLayout_card__Ik0MG [class*=Code_container] {
  padding: 0;
  margin-top: 0;
}
.LoginLayout_card__Ik0MG [class*=Code_container] label {
  color: #1f1f2e;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
}
.LoginLayout_card__Ik0MG [class*=Code_container] [class*=Code_dashed] span {
  color: var(--lg-title);
  border-bottom-color: var(--lg-title);
  font-size: 18px;
}

.LoginLayout_title__rkJDc + form,
.LoginLayout_title__rkJDc + .LoginLayout_error__dodKf,
.LoginLayout_title__rkJDc + .LoginLayout_success__DiyX2 {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/LoginLayout/LoginLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EAAY,YAAA;EAAc,WAAA;AAG1B;;AADA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAIF;;AADA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAIF;AAFE;EAAO,aAAA;EAAe,sBAAA;EAAwB,SAAA;AAOhD;;AAJA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAOF;;AAJA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAOF;;AAJA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAOF;AALE;EAAQ,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAU7C;AARE;EACE,WAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAUJ;AARI;EAAU,+BAAA;EAAiC,4EAAA;AAY/C;;AARA;EAAY,kBAAA;AAYZ;;AAXA;EAAkB,mBAAA;AAelB;;AAbA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAgBF;AAdE;EAAW,oBAAA;AAiBb;;AAdA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;AAiBF;;AAdA;EACE,wBAAA;EACA,qBAAA;AAiBF;AAhBE;EAAU,0BAAA;AAmBZ;;AAhBA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAmBF;AAjBE;EAAa,YAAA;EAAc,mBAAA;AAqB7B;AApBE;EAAyB,yBAAA;AAuB3B;;AApBA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAuBF;;AApBA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAuBF;;AApBA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAuBF;;AApBA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAuBF;;AApBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;AAuBF;;AApBA;EACE,cAAA;EACA,qBAAA;AAuBF;AAtBE;EAAU,wBAAA;EAA0B,0BAAA;AA0BtC;;AAvBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA0BF;AAxBE;EAAM,WAAA;EAAa,YAAA;AA4BrB;AA3BE;EAAO,kBAAA;AA8BT;;AA3BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mCAAA;EACA,+VACE;EAIF,sBAAA;EACA,2BAAA;AA0BF;;AAvBA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,2CAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EACA,WAAA;AA0BF;AAxBE;EAAI,gBAAA;EAAkB,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA8BzD;AA5BE;EAAK,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,SAAA;EAAW,UAAA;EAAY,gBAAA;AAoCxE;AAlCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,2CAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAoCJ;AAlCI;EAAY,WAAA;EAAa,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,gBAAA;AAyC1E;;AArCA;EACE;IAAQ,YAAA;IAAc,iBAAA;EA0CtB;EAzCA;IAAU,aAAA;EA4CV;AACF;AAzCA;EACE,UAAA;EACA,aAAA;AA2CF;AAzCE;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,UAAA;AA+C7D;AA9CE;EAA8B,sBAAA;EAAwB,oCAAA;EAAsC,eAAA;AAmD9F;;AA/CA;;;EAEoB,gBAAA;AAmDpB","sourcesContent":[".page {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  min-height: 560px;\n  padding: 0;\n  gap: 0;\n  background: #fff;\n  color: #1f1f2e;\n  box-sizing: border-box;\n}\n\n.left {\n  padding: 24px 24px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 50%;\n  min-width: 0;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  min-height: 40px;\n}\n\n.logo-img { height: 36px; width: auto; }\n\n.main {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 0;\n}\n\n.card {\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n\n  form { display: flex; flex-direction: column; gap: 16px; }\n}\n\n.title {\n  margin: 0 0 8px;\n  font-size: 28px;\n  line-height: 1.2;\n  font-weight: 600;\n  color: var(--lg-title);\n}\n\n.subtitle {\n  margin: 0 0 28px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #55556a;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  label { font-size: 12px; font-weight: 600; color: #1f1f2e; }\n\n  input {\n    width: 100%;\n    box-sizing: border-box;\n    height: 40px;\n    padding: 0 12px;\n    border: 1px solid #55556a;\n    border-radius: 6px;\n    font-size: 14px;\n    background: #fff;\n    outline: none;\n\n    &:focus { border-color: var(--lg-primary); box-shadow: 0 0 0 3px color-mix(in srgb, var(--lg-primary) 20%, transparent); }\n  }\n}\n\n.password { position: relative; }\n.password input { padding-right: 40px; }\n\n.eye {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  display: flex;\n  padding: 4px;\n  border: 0;\n  background: none;\n  cursor: pointer;\n\n  svg path { fill: var(--lg-dark); }\n}\n\n.forgot {\n  align-self: flex-end;\n  margin-top: -8px;\n  font-size: 12px;\n}\n\n.link, .forgot, .footer a {\n  color: var(--lg-primary);\n  text-decoration: none;\n  &:hover { text-decoration: underline; }\n}\n\n.submit {\n  align-self: center;\n  min-width: 150px;\n  height: 40px;\n  margin-top: 8px;\n  padding: 0 24px;\n  border: 0;\n  border-radius: 6px;\n  background: var(--lg-primary);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:disabled { opacity: 0.5; cursor: not-allowed; }\n  &:not(:disabled):hover { background: var(--lg-mid); }\n}\n\n.alt {\n  margin-top: 24px;\n  text-align: center;\n  font-size: 12px;\n  color: #55556a;\n}\n\n.error {\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #fdecee;\n  color: #a50f1d;\n  font-size: 12px;\n}\n\n.field-error {\n  font-size: 11px;\n  line-height: 1.5;\n  color: var(--lg-mid);\n}\n\n.success {\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #e8f6ec;\n  color: #1d6b34;\n  font-size: 12px;\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 16px 0;\n  border-top: 1px solid #ececf2;\n  font-size: 11px;\n  color: #55556a;\n}\n\n.footer .footer-link {\n  color: inherit;\n  text-decoration: none;\n  &:hover { color: var(--lg-primary); text-decoration: underline; }\n}\n\n.secure {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n\n  svg { width: 12px; height: 12px; }\n  path { fill: currentColor; }\n}\n\n.visual {\n  position: relative;\n  flex: 1 1 50%;\n  align-self: stretch;\n  border-radius: 14px 0 0 14px;\n  overflow: hidden;\n  background-color: var(--lg-primary);\n  background-image:\n    radial-gradient(ellipse 34% 30% at 55% 55%, rgba(255, 255, 255, 0.32) 0, rgba(255, 255, 255, 0) 100%),\n    radial-gradient(ellipse 45% 40% at 100% 0%, var(--lg-dark) 0, transparent 100%),\n    radial-gradient(ellipse 55% 45% at 0% 78%, var(--lg-dark) 0, transparent 100%),\n    linear-gradient(135deg, var(--lg-primary) 0%, var(--lg-primary) 100%);\n  background-size: cover;\n  background-position: center;\n}\n\n.glass {\n  position: absolute;\n  left: 5%;\n  bottom: 5%;\n  width: 50%;\n  min-width: 260px;\n  padding: 28px 32px 22px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(14px);\n  color: #fff;\n\n  p { margin: 0 0 16px; font-size: 16px; line-height: 2; font-weight: 400; }\n\n  ul { display: flex; flex-wrap: wrap; gap: 8px; margin: 0; padding: 0; list-style: none; }\n\n  li {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.35);\n    border-radius: 999px;\n    font-size: 10px;\n    font-weight: 500;\n\n    &::before { content: ''; width: 4px; height: 4px; border-radius: 50%; background: #fff; }\n  }\n}\n\n@media (max-width: 900px) {\n  .page { height: auto; min-height: 100vh; }\n  .visual { display: none; }\n}\n\n// Champ code (confirmation d'inscription) : composant partagé pensé pour fond sombre.\n.card [class*='Code_container'] {\n  padding: 0;\n  margin-top: 0;\n\n  label { color: #1f1f2e; font-size: 12px; font-weight: 600; padding: 0; }\n  [class*='Code_dashed'] span { color: var(--lg-title); border-bottom-color: var(--lg-title); font-size: 18px; }\n}\n\n// Sans sous-titre, on garde de l'air entre le titre et le contenu.\n.title + form,\n.title + .error,\n.title + .success { margin-top: 20px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `LoginLayout_page__9xLw9`,
	"left": `LoginLayout_left__wLC52`,
	"header": `LoginLayout_header__8uZat`,
	"logo-img": `LoginLayout_logo-img__Pwqs+`,
	"main": `LoginLayout_main__PVL5R`,
	"card": `LoginLayout_card__Ik0MG`,
	"title": `LoginLayout_title__rkJDc`,
	"subtitle": `LoginLayout_subtitle__30W-j`,
	"field": `LoginLayout_field__jizQt`,
	"password": `LoginLayout_password__qSxGe`,
	"eye": `LoginLayout_eye__SYfVf`,
	"forgot": `LoginLayout_forgot__Qdp58`,
	"link": `LoginLayout_link__ArUGf`,
	"footer": `LoginLayout_footer__lsm4Q`,
	"submit": `LoginLayout_submit__yLtTL`,
	"alt": `LoginLayout_alt__4FoeL`,
	"error": `LoginLayout_error__dodKf`,
	"field-error": `LoginLayout_field-error__Ivzzk`,
	"success": `LoginLayout_success__DiyX2`,
	"footer-link": `LoginLayout_footer-link__4xk-U`,
	"secure": `LoginLayout_secure__a5THh`,
	"visual": `LoginLayout_visual__leyTl`,
	"glass": `LoginLayout_glass__JaNSt`
};
export default ___CSS_LOADER_EXPORT___;
